import React, { useState, useEffect } from 'react';
import { Container, Title, Text, TextInput, Button, Group, Stack } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

function HomePage() {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    const match = document.cookie.match(/(?:^|;\s*)lp_client_id=([^;]*)/);
    if (match) {
      setInputValue(match[1]);
    }
  }, []);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNavigate = () => {
    const trimmedInput = inputValue.trim();
    if (trimmedInput) {
      if (trimmedInput.startsWith('lingva-pro.org')) {
        const parts = trimmedInput.split('/');
        const id = parts[1];
        if (id) {
          navigate(`/${id}`);
        }
      } else {
        navigate(`/${trimmedInput}`);
      }
    }
  };

  return (
    <div style={{ background: 'var(--gradient-hero)', minHeight: '100vh' }}>
      <Container size="sm" style={{ paddingTop: '20vh' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Stack align="center" gap="lg">
            <Title order={1} ta="center" style={{ fontSize: 'clamp(32px, 5vw, 48px)', color: 'var(--text-primary)' }}>
              {t('homePageTitle')}
            </Title>
            <Text size="lg" c="var(--text-secondary)" ta="center">
              {t('homePageSubtitle')}
            </Text>
            <Group gap="sm" justify="center">
              <TextInput
                placeholder={t('enterCodePlaceholder')}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleNavigate()}
                style={{ width: 300 }}
                styles={{
                  input: {
                    border: '2px solid #e2e8f0',
                    '&:focus': { borderColor: 'var(--primary)' },
                  },
                }}
              />
              <Button
                className="gradient-btn"
                size="lg"
                onClick={handleNavigate}
              >
                {t('navigateButton')}
              </Button>
            </Group>
            <Text size="sm" c="var(--text-muted)" ta="center" mt="md">
              {t('homePageFooter')}
            </Text>
          </Stack>
        </motion.div>
      </Container>
    </div>
  );
}

export default HomePage;
